import WebSocketManager from '../../api/webSocketManager';
// SINGLETON ALERT!
const cachedWebSocketManagers = {};
export function getWebSocketManager(instanceId, onSocketMessage, onSocketClosed) {
    const existingWebSocketManager = cachedWebSocketManagers[instanceId];
    if (existingWebSocketManager) {
        return existingWebSocketManager;
    }
    console.log(`Creating WebSocketManager, instance ${instanceId}`);
    const newWebSocketManager = new WebSocketManager({ instanceId, onSocketMessage, onSocketClosed });
    cachedWebSocketManagers[instanceId] = newWebSocketManager;
    return newWebSocketManager;
}
export function deleteWebSocketManager(instanceId) {
    console.log(`Deleting WebSocketManager, instance ${instanceId}`);
    delete cachedWebSocketManagers[instanceId];
}
